import { render, staticRenderFns } from "./FormAddNewInstruction.vue?vue&type=template&id=570f8944&scoped=true"
import script from "./FormAddNewInstruction.vue?vue&type=script&lang=js"
export * from "./FormAddNewInstruction.vue?vue&type=script&lang=js"
import style0 from "./FormAddNewInstruction.vue?vue&type=style&index=0&id=570f8944&prod&lang=scss&scoped=true"
import style1 from "./FormAddNewInstruction.vue?vue&type=style&index=1&id=570f8944&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570f8944",
  null
  
)

export default component.exports